import { connect } from 'react-redux';
import UserManagementListView from './UserManagementListView';
import { showSettingsSideMenu, hideSettingsSideMenu }
  from 'src/legacy/redux/actions/settings.jsx';
import { fetchUserManagementList, inviteUser, invalidateErrorMessage, selectUser, invalidateUser, 
         updateUserActivation, updateUserAccess, resendInvitation, 
         deleteInvitation} from 'src/legacy/redux/actions/userManagement.jsx';
import { fetchUserGroup } from 'src/legacy/redux/actions/userGroups';      
import hasAccess from 'src/legacy/services/hasAccess';
import withUseHooks from 'src/legacy/components/withUseHooks';
import _ from 'lodash';

const mapStateToProps = (state, ownProps) => {
  return {
    loading: state.legacyRootReducer.settings.userManagement.loading,
    currentPage: state.legacyRootReducer.settings.userManagement.pagination.current,
    totalPages: state.legacyRootReducer.settings.userManagement.pagination.totalPages,
    showSettingsMenu: state.legacyRootReducer.settings.settingsMenu.showSettingsMenu,
    users: state.legacyRootReducer.settings.userManagement.items,
    errorMessage: state.legacyRootReducer.settings.userManagement.inviteError,
    inviting: state.legacyRootReducer.settings.userManagement.inviting,
    deleting: state.legacyRootReducer.settings.userManagement.deleting,
    updating: _.get(state, 'legacyRootReducer.settings.userManagement.users.updating'),
    user: state.legacyRootReducer.settings.userManagement.user
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showSettingsSideMenu: () => {
       dispatch(showSettingsSideMenu());
    },
    fetchUserManagementList: (page, query, filter) => {
      dispatch(fetchUserManagementList(page, query, filter))
    },
    hideSettingsSideMenu: () => {
        dispatch(hideSettingsSideMenu())
    },
    inviteUser: (user) => {
        return dispatch(inviteUser(user))
    },

    invalidateErrorMessage: () => {
        dispatch(invalidateErrorMessage())
    },

    selectUser: (user) => {
       return dispatch(selectUser(user))
    },

    updateUserActivation: (user) => {
       dispatch(updateUserActivation(user))
    },

    updateUserAccess: (user) => {
      dispatch(updateUserAccess(user))
    },

    resendInvitation: (id) => {
      dispatch(resendInvitation(id))
    },
    deleteInvitation: (id) => {
      return dispatch(deleteInvitation(id));
    },
    fetchUserGroup: (id) => {
      return dispatch(fetchUserGroup(id));
    }
  }
}

const UserManagementListContainer = connect (
    mapStateToProps,
    mapDispatchToProps
)(UserManagementListView);

// export default hasAccess(UserManagementListContainer, 'user-management');
export default withUseHooks(UserManagementListContainer);